<template>
    <div class="tab-pane fade" :class="{'show active': current_step === 1, 'loading': loading}" id="luminaire-selection-step" role="tabpanel" aria-labelledby="luminaire-selection-step-tab">
        <form action="" @submit.prevent>
            <div class="accordion md-accordion pt-4" id="lst-accordion" role="tablist" aria-multiselectable="true">
                <!-- Accordion cards for Selection Steps -->
                <div class="card lst-steps" v-for="(luminaire_selection_step, lssIndex) in luminaire_selection_steps">
                    <!-- Card header -->
                    <div class="card-header px-0 py-3" role="tab" :id="'heading-' + luminaire_selection_step.id" :class="(luminaire_selection_step.product_attribute_name in lstForm && lstForm[luminaire_selection_step.product_attribute_name]) ? 'valid-step' : 'not-valid-step'">
                        <a data-toggle="collapse" data-parent="#lst-accordion" :href="'#lst-step-' + luminaire_selection_step.order" :aria-expanded="lssIndex === 0 ? 'true' : 'false'" :aria-controls="'lst-step-' + luminaire_selection_step.order" :class="{ 'collapsed' : lssIndex > 0 }">
                            <h4 class="m-0 text-white d-flex justify-content-between">
                                <span>{{ $t(luminaire_selection_step.title) }} <i class="fas fa-check-circle text-primary" v-if="luminaire_selection_step.product_attribute_name in lstForm && lstForm[luminaire_selection_step.product_attribute_name]"></i></span> <i class="fas fa-chevron-down rotate-icon text-primary"></i>
                            </h4>
                        </a>
                    </div>
                    <!-- Card body -->
                    <div :id="'lst-step-' + luminaire_selection_step.order" :class="['collapse', { 'show' : lssIndex === 0 }]" role="tabpanel" :aria-labelledby="'heading-lst-step-' + luminaire_selection_step.order" data-parent="#lst-accordion">
                        <div class="card-body px-0 py-3">
                            <div class="container-fluid px-0">
                                <ul class="list-unstyled row">
                                    <!-- normal selection step options -->
                                    <li class="col-6 col-sm-4 pb-4" v-for="(luminaire_selection_option, lsoIndex) in filteredLstOptions"
                                        v-if="luminaire_selection_option.luminaire_selection_step_id === luminaire_selection_step.id">
                                        <div class="custom-control custom-radio image-checkbox" :class="'lst-step-' + luminaire_selection_step.id + '-option-' + lsoIndex">
                                            <input
                                                v-if="!isOptionDisabled(luminaire_selection_option.id)"
                                                v-model="lstForm[luminaire_selection_step.product_attribute_name]"
                                                :value="luminaire_selection_option.id"
                                                @change="goToNextSection($event, luminaire_selection_step.order); filterLstOptions(); setSelectedOptions();"
                                                type="radio"
                                                class="custom-control-input"
                                                :id="'lst-step-' + luminaire_selection_step.id + '-option-' + lsoIndex"
                                                :name="'lst-step-' + luminaire_selection_step.id + '-options'">
                                            <label
                                                class="custom-control-label w-100" :for="'lst-step-' + luminaire_selection_step.id + '-option-' + lsoIndex"
                                                :class="{ 'disabled-luminaire-selection-option':isOptionDisabled(luminaire_selection_option.id) }">
                                                <img
                                                    :src="asset('lst/' + ( $i18n.locale === 'en' && luminaire_selection_option.picture_file_name_en ? luminaire_selection_option.picture_file_name_en : luminaire_selection_option.picture_file_name))"
                                                    alt="#"
                                                    class="img-fluid w-100"
                                                    v-if="luminaire_selection_option.picture_file_name"
                                                    :class="{'no-click': luminaire_selection_option.id === 16}">
                                                <p class="text-white text-center pt-2 mb-0" v-if="luminaire_selection_option.title"><strong>{{ $t( luminaire_selection_option.title ) }}</strong> <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t( luminaire_selection_option.tooltip )" v-if="luminaire_selection_option.tooltip"></i></p>
                                                <p class="text-light text-center pt-1 mb-0 small" v-if="luminaire_selection_option.description">{{ $t( luminaire_selection_option.description ) }}</p>
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Accordion card -->
                <div>
                    <download-dialux-data-button
                        v-if="false && lstForm.led_module_serie_id && lstForm.led_module_optics_id && lstForm.led_module_power_id && lstForm.led_module_color_rendering_index_id && lstForm.led_module_color_temperature_id"
                        :product_configurator_id="product_configurator_id"
                        :plannings="[lstForm]"
                        :generatedSku="generatedSku"
                        :button_class="'btn-outline-primary'"
                        @update-loading="updateLoading" />

                    <download-tender-text-button
                        v-if="validatedSteps.includes(1)"
                        :product_configurator_id="product_configurator_id"
                        :planning_data="lstForm"
                        :planning_id="0"
                        :button_class="'btn-outline-primary'"
                        @update-loading="updateLoading" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        props: [
            'current_step',
            'product_configurator_id',
            'validatedSteps',
            'editPlanning',
            'existingSku',
            'ledModuleConfiguration'
        ],
        data() {
            return {
                loading: true,
                lstForm: {
                    led_module_name: '',
                },
                luminaire_selection_steps: [],
                luminaire_selection_options: [],
                filteredLstOptions: [],

                disabledOptionIds: [16, 15, 13, 4],

                stepOneValidated: false,
                selectedOptions: [],
                selectedSerie: '',
                selectedControl: '',
                selectedHousingColor: '',
                selectedOptics: '',
                selectedProtectionClass: '',

                calculatedProductPrice: '',
                generatedSku: '',
                generatedProductName: '',

                dataLoaded: false,

                luminaireLineProducts: {
                    mountingRails: [],
                    blindModules: [],
                    electricalFeeds: [],
                    mountConnectors: [],
                    suspensions: [],
                    mountingAdapter: [],
                    emergency_lights: [],
                    luminaire_controls: [],
                    cable_routes: [],
                    mounting_adapter_tools: [],
                    universal_adapters: [],
                    optics: [],
                },

            }
        },

        methods: {

            updateLoading(value) {
                this.$emit('update-loading', value);
            },

            /**************************************************************************
             * LOAD DATA
             **************************************************************************/

            loadLuminaireSelectionSteps() {

                 axios.get('/api/luminaire_selection_steps/' + this.product_configurator_id)
                    .then((response) => {
                        this.luminaire_selection_steps = response.data.data;

                        if (!this.editPlanning && this.luminaire_selection_options && this.luminaire_selection_options.length > 0) {
                            this.$emit('update-loading', false);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });

            },

            loadLuminaireSelectionOptions() {

                axios.get('/api/luminaire_selection_options/' + this.product_configurator_id)
                    .then((response) => {
                        this.luminaire_selection_options = response.data.data;
                        this.filterLstOptions();

                        if (!this.editPlanning && this.luminaire_selection_steps && this.luminaire_selection_steps.length > 0) {
                            this.$emit('update-loading', false);
                        } else {
                            this.setLedConfiguration();
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (!this.editPlanning) {
                            this.$emit('update-loading', false);
                        }
                    });
                this.loading = false;

            },

            /**************************************************************************
             * PROCESS FORM
             **************************************************************************/

            validateStepOne() {

                let step_1_validated = false;

                // Validate Step 1 - if all steps -> then validated
                let step_1_validated_counter = 0;

                this.luminaire_selection_steps.forEach( lstStep => {
                    if ( this.lstForm[lstStep.product_attribute_name] ) {
                        step_1_validated_counter++;
                    }
                });

                if ( step_1_validated_counter < this.luminaire_selection_steps.length || step_1_validated_counter > this.luminaire_selection_steps.length ) {
                    step_1_validated = 'step_1_not_valid';
                    this.allLuminaireSelectionStepsSelected = false;
                    // Set allLuminaireSelectionStepsSelected to false
                    this.$emit('update-all-luminaire-selection-steps-selected', false);
                } else {
                    step_1_validated = 'step_1_valid';
                    // Set allLuminaireSelectionStepsSelected to true
                    this.$emit('update-all-luminaire-selection-steps-selected', true);
                    this.allLuminaireSelectionStepsSelected = true;
                }

                console.log('Step One Validated:', this.allLuminaireSelectionStepsSelected);

                this.stepOneValidated = step_1_validated;

            },

            setSelectedOptions() {
                let selectedOptions = [];

                if (this.product_configurator_id
                    && this.lstForm
                    && this.luminaire_selection_options && this.luminaire_selection_options.length > 0
                    && this.luminaire_selection_steps && this.luminaire_selection_steps.length > 0) {

                    this.checkProtectionClass();

                    for (const [key, value] of Object.entries(this.lstForm)) {
                        if (key !== 'led_module_name') {
                            selectedOptions.push(this.luminaire_selection_options.find(option => option.id === value));
                        }
                    }

                    // sort selectedOptions array by Luminaire Selection Step Order
                    selectedOptions.sort((a,b) => {
                        if(a.luminaire_selection_step.order < b.luminaire_selection_step.order) return -1;
                        if(a.luminaire_selection_step.order > b.luminaire_selection_step.order) return 1;
                        return 0;
                    });


                    this.selectedOptions = selectedOptions;

                    if (this.editPlanning) {
                        this.$emit('update-loading', false);
                    }

                    this.$emit('update-selected-options', selectedOptions);
                    this.loading = false;

                    this.checkIfSelectedOptionsAreValid();

                }


            },

            updateLedConfigurations() {

                if ( this.lstForm.led_module_serie_id === 1 || this.lstForm.led_module_serie_id === 44  ) {
                    this.selectedSerie = 'eco';
                } else if ( this.lstForm.led_module_serie_id === 2 ) {
                    this.selectedSerie = 'max_10';
                } else if ( this.lstForm.led_module_serie_id === 42 ) {
                    this.selectedSerie = 'max_12';
                } else if ( this.lstForm.led_module_serie_id === 43 ) {
                    this.selectedSerie = 'max_14';
                } else {
                    this.selectedSerie = '';
                }

                if (this.lstForm.led_module_control_id) {
                    this.selectedControl = this.lstForm.led_module_control_id;
                } else {
                    this.selectedControl = '';
                }

                if (this.lstForm.led_module_housing_color_id) {
                    this.selectedHousingColor = this.lstForm.led_module_housing_color_id;
                } else {
                    this.selectedHousingColor = '';
                }

                if (this.lstForm.led_module_optics_id) {
                    this.selectedOptics = this.lstForm.led_module_optics_id;
                } else {
                    this.selectedOptics = '';
                }

                if (this.lstForm.led_module_protection_class_id) {
                    this.checkProtectionClass();
                    this.selectedProtectionClass = this.lstForm.led_module_protection_class_id;
                } else {
                    this.selectedProtectionClass = '';
                }

                this.generateSku();
            },

            generateSku() {

                let generatedSku = '';

                if (this.selectedOptions.length === this.luminaire_selection_steps.length) {
                    generatedSku = '';
                    for (const [key, value] of Object.entries(this.selectedOptions)) {
                        generatedSku = generatedSku + value.partial_sku;
                    }
                }
                this.generatedSku = generatedSku;
            },

            generateProductName() {

                if (!this.luminaire_selection_steps && !this.luminaire_selection_options) return;

                let generatedProductName = '';
                let productTitle = '';
                let productPower = '';

                if (this.selectedOptions.length > 0 && this.selectedOptions.find(item => item.luminaire_selection_step_id === 1) ) {
                    // if Serie is selected
                    productTitle = 'tempLED ' + this.selectedOptions.find(item => item.luminaire_selection_step_id === 1).title;
                }

                // if Leistung is selected
                if (this.selectedOptions.length > 0 && this.selectedOptions.find(item => item.luminaire_selection_step_id === 8) ) {
                    productPower = this.selectedOptions.find(item => item.luminaire_selection_step_id === 8).title;
                }

                if ( productTitle.length > 0 ) {
                    generatedProductName = this.$t(productTitle, 'de') + ' ' + this.$t(productPower, 'de');
                }

                this.lstForm.led_module_name = generatedProductName;

                this.generatedProductName = generatedProductName;

            },

            checkProtectionClass () {
                // if IP55 selected and Serie is eco, then change to IP44
                if ( this.lstForm.led_module_protection_class_id === 15 ) {
                    this.lstForm.led_module_protection_class_id = 14;
                }
            },

            /**************************************************************************
             * EDIT
             **************************************************************************/

            setLedConfiguration() {

                if (!this.product_configurator_id || !this.ledModuleConfiguration || !this.luminaire_selection_options || !this.luminaire_selection_options) {
                    return;
                }

                this.lstForm = this.ledModuleConfiguration;

                this.setSelectedOptions();

            },



            /**************************************************************************
             * GENERAL
             **************************************************************************/

            isOptionDisabled(optionId) {
                return this.disabledOptionIds.includes(optionId);
            },

            activateTooltips () {
                $( document ).ready(function() {
                    setTimeout(function() {
                        $('[data-toggle="tooltip"]').tooltip();
                    }, 2000);
                });
            },

            goToNextSection: function (event, lssOrder) {
                lssOrder++;
                $('#lst-step-' + lssOrder + '.collapse').collapse('show');
            },

            /**
             * Check if URL has a specific parameter
             * @param {string} paramName - The parameter name to check for
             * @param {string} [valueToMatch] - Optional specific value to match
             * @returns {boolean|string} - True if parameter exists with matching value, or the parameter value if valueToMatch is null
             */
            hasUrlParam(paramName, valueToMatch = null) {
                const urlParams = new URLSearchParams(window.location.search);
                if (!valueToMatch) {
                    if (urlParams.has(paramName)) {
                        return urlParams.get(paramName) || true;
                    }
                    return false;
                }
                return urlParams.has(paramName) && urlParams.get(paramName) === valueToMatch;
            },

            checkIfSelectedOptionsAreValid() {
                const isValid = this.selectedOptions.every(option => {
                        return this.filteredLstOptions.some(filteredOption => filteredOption.id === option.id)
                    }
                );

                if (!isValid) {
                    this.unsetInvalidSelectedOptions();
                }

                return isValid;
            },

            unsetInvalidSelectedOptions() {
                this.selectedOptions = this.selectedOptions.filter(option =>
                    this.filteredLstOptions.some(filteredOption => filteredOption.id === option.id)
                );

                // Update lstForm to remove invalid options
                for (const step of this.luminaire_selection_steps) {
                    if (!this.selectedOptions.some(option => option.luminaire_selection_step_id === step.id)) {
                        // Remove the option from selectedOptions & lstForm
                        this.selectedOptions = this.selectedOptions.filter(selectedOption => selectedOption.luminaire_selection_step_id !== step.id);
                        this.lstForm[step.product_attribute_name] = null;

                    }
                }
            },

            filterLstOptions() {

                let options = this.luminaire_selection_options;

                // Also create dependencies on known specific fields that affect filtering
                const ambient_temp_id = this.lstForm.led_module_ambient_temperature_id;
                const color_temp_id = this.lstForm.led_module_color_temperature_id;

                // If 70° selected, remove 3 Options from Steuerung and Leistung (Options not active at the moment)
                if (ambient_temp_id === 35) {
                    options = options.filter(el => el.id !== 30 );  // Casambi
                    options = options.filter(el => el.id !== 33 );  // Notlichtbaustein 3 h mit 3 W
                    options = options.filter(el => el.id !== 34 );  // Notlicht über Zentralbatarie
                    options = options.filter(el => el.id !== 45);   // 15 Watts
                }

                // If Color temperature is not 4000 (ID 9) or 5000 then disable Ra90 (ID 12)
                if (color_temp_id !== 9 && color_temp_id !== 10) {
                    options = options.filter(el => el.id !== 12 );
                }

                this.filteredLstOptions = options;

            },

            /**
             * Handle different prefill modes based on URL parameter
             */
            handlePrefill() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    return;
                }

                // Check if there's an SKU parameter
                const skuParam = this.hasUrlParam('sku');
                if (skuParam && this.prefillFromSku(skuParam)) {
                    // If we successfully prefilled from SKU, return early
                    return;
                }

                // Otherwise handle regular prefill modes
                const prefillValue = this.hasUrlParam('prefill');

                switch(prefillValue) {
                    case '1':
                        // Select first option for each step
                        this.autoSelectFirstOptions();
                        break;
                    case 'random':
                        // Select random options for each step
                        this.autoSelectRandomOptions();
                        break;
                    case 'eco':
                        // First option for first step, random for others
                        this.autoSelectEcoOptions();
                        break;
                    case 'max':
                        // Random option (except first) for first step, random for others
                        this.autoSelectMaxOptions();
                        break;
                    default:
                        // Default to first options if value is not recognized
                        this.autoSelectFirstOptions();
                        break;
                }
            },

            /**
             * Prefill form based on SKU parameter
             * @param {string} sku - The SKU string (18 digits)
             * @returns {boolean} - True if prefill was successful, false otherwise
             */
            prefillFromSku(sku) {
                // Validate SKU is exactly 18 digits
                if (!sku || !/^\d{18}$/.test(sku)) {
                    console.log('Invalid SKU format. Must be exactly 18 digits.');
                    return false;
                }

                console.log(`Prefilling form from SKU: ${sku}`);

                // Split SKU into chunks of 2 digits
                const skuChunks = [];
                for (let i = 0; i < sku.length; i += 2) {
                    skuChunks.push(sku.substring(i, i + 2));
                }

                // Sort steps by order to ensure correct mapping
                const sortedSteps = [...this.luminaire_selection_steps].sort((a, b) => a.order - b.order);

                // Check if we have the right number of chunks for our steps
                if (skuChunks.length !== sortedSteps.length) {
                    console.log(`SKU chunks count (${skuChunks.length}) doesn't match steps count (${sortedSteps.length})`);
                    return false;
                }

                let allOptionsFound = true;

                // Map each chunk to its corresponding step
                sortedSteps.forEach((step, index) => {
                    const partialSku = skuChunks[index];

                    // Find the option with matching partial SKU for this step
                    const matchingOption = this.luminaire_selection_options.find(option =>
                        option.luminaire_selection_step_id === step.id &&
                        option.partial_sku === partialSku
                    );

                    if (matchingOption && !this.isOptionDisabled(matchingOption.id)) {
                        // Set the option in the form
                        this.lstForm[step.product_attribute_name] = matchingOption.id;
                    } else {
                        console.log(`No matching option found for step ${step.id} with partial SKU ${partialSku}`);
                        allOptionsFound = false;
                    }
                });

                if (allOptionsFound) {
                    // Update the form and trigger necessary updates
                    this.setSelectedOptions();
                    return true;
                } else {
                    console.log('Some options could not be found. Falling back to default prefill.');
                    return false;
                }
            },

            /**
             * Auto-select the first available option for each luminaire selection step
             */
            autoSelectFirstOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting first options for each step');

                // Process each step
                this.luminaire_selection_steps.forEach(step => {
                    // Find the first non-disabled option for this step
                    const options = this.filteredLstOptions.filter(
                        option => option.luminaire_selection_step_id === step.id
                    );

                    if (options.length > 0) {
                        // Find first non-disabled option
                        const firstValidOption = options.find(option => !this.isOptionDisabled(option.id));

                        if (firstValidOption) {
                            // Set the option in the form
                            this.lstForm[step.product_attribute_name] = firstValidOption.id;
                        }
                    }
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

            /**
             * Auto-select random options for each luminaire selection step
             */
            autoSelectRandomOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select random options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting random options for each step');

                // Process each step
                this.luminaire_selection_steps.forEach(step => {
                    this.selectRandomOptionForStep(step);
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

            /**
             * Select a random option for a specific step
             * @param {Object} step - The step to select a random option for
             * @param {Array} [excludeOptions] - Optional array of option IDs to exclude
             */
            selectRandomOptionForStep(step, excludeOptions = []) {
                // Find all valid options for this step
                let validOptions = this.filteredLstOptions
                    .filter(option => option.luminaire_selection_step_id === step.id)
                    .filter(option => !this.isOptionDisabled(option.id));

                // Exclude specific options if needed
                if (excludeOptions.length > 0) {
                    validOptions = validOptions.filter(option => !excludeOptions.includes(option.id));
                }

                if (validOptions.length > 0) {
                    // Select a random option from the valid options
                    const randomIndex = Math.floor(Math.random() * validOptions.length);
                    const randomOption = validOptions[randomIndex];

                    // Set the random option in the form
                    this.lstForm[step.product_attribute_name] = randomOption.id;
                }
            },

            /**
             * Auto-select options for 'eco' mode:
             * - First option for first step
             * - Random options for all other steps
             */
            autoSelectEcoOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select eco options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting eco options: first for first step, random for others');

                // Sort steps by order to ensure we get the first step correctly
                const sortedSteps = [...this.luminaire_selection_steps].sort((a, b) => a.order - b.order);

                // Process each step
                sortedSteps.forEach((step, index) => {
                    if (index === 0) {
                        // For the first step, select the first option
                        const options = this.filteredLstOptions.filter(
                            option => option.luminaire_selection_step_id === step.id
                        );

                        if (options.length > 0) {
                            // Find first non-disabled option
                            const firstValidOption = options.find(option => !this.isOptionDisabled(option.id));

                            if (firstValidOption) {
                                // Set the option in the form
                                this.lstForm[step.product_attribute_name] = firstValidOption.id;
                            }
                        }
                    } else {
                        // For all other steps, select a random option
                        this.selectRandomOptionForStep(step);
                    }
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

            /**
             * Auto-select options for 'max' mode:
             * - Random option (except first) for first step
             * - Random options for all other steps
             */
            autoSelectMaxOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select max options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting max options: random (except first) for first step, random for others');

                // Sort steps by order to ensure we get the first step correctly
                const sortedSteps = [...this.luminaire_selection_steps].sort((a, b) => a.order - b.order);

                // Process each step
                sortedSteps.forEach((step, index) => {
                    if (index === 0) {
                        // For the first step, find all options
                        const options = this.filteredLstOptions.filter(
                            option => option.luminaire_selection_step_id === step.id
                        );

                        if (options.length > 0) {
                            // Find first non-disabled option to exclude
                            const firstValidOption = options.find(option => !this.isOptionDisabled(option.id));

                            if (firstValidOption) {
                                // Select a random option excluding the first one
                                this.selectRandomOptionForStep(step, [firstValidOption.id]);
                            } else {
                                // If no valid first option, just select any random option
                                this.selectRandomOptionForStep(step);
                            }
                        }
                    } else {
                        // For all other steps, select a random option
                        this.selectRandomOptionForStep(step);
                    }
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

            checkForLuminaireControlReset () {
                if ( this.lstForm.led_module_control_id === 27 || this.lstForm.led_module_control_id === 28 || this.lstForm.led_module_control_id === 29 ) {
                    return true;
                } else {
                    return false;
                }
            },

        },

        mounted() {
            if (this.product_configurator_id === 1 && !this.dataLoaded) {
                this.loadLuminaireSelectionSteps();
                this.loadLuminaireSelectionOptions();
                this.activateTooltips();

                // Auto-select options if prefill or sku parameter is present
                if (this.hasUrlParam('prefill') || this.hasUrlParam('sku')) {
                    // Wait for data to be loaded before selecting options
                    setTimeout(() => {
                        this.handlePrefill();
                    }, 1000);
                }

                this.dataLoaded = true;
            }
        },

        watch: {
            // Watch for changes in the lstForm object
            lstForm: {
                handler (newVal, oldVal) {
                    this.$emit('update-lst-form', newVal);
                },
                deep: true
            },

            product_configurator_id: function(value) {
                if (!this.dataLoaded) {
                    this.loadLuminaireSelectionSteps();
                    this.loadLuminaireSelectionOptions();
                    this.activateTooltips();

                    // Auto-select options if prefill or sku parameter is present
                    if (this.hasUrlParam('prefill') || this.hasUrlParam('sku')) {
                        // Wait for data to be loaded before selecting options
                        setTimeout(() => {
                            this.handlePrefill();
                        }, 1000);
                    }

                    this.dataLoaded = true;
                }
            },

            selectedSerie: function(value) {
                this.$emit('update-selected-serie', value);
            },

            /*selectedControl: function(value) {
                this.checkForLuminaireControlReset();
            },*/

            luminaireLineProducts: {
                handler(val, oldVal){
                    this.$emit('update-luminaire-line-products', val);
                },
                deep: true
            },

            generatedProductName: function(value) {
                this.$emit('update-generated-product-name', value);
            },

            stepOneValidated: function(value) {
                this.$emit('update-step-1-validated', value);
            },

            selectedControl: function(value) {
                this.$emit('update-selected-control', value);
            },

            selectedHousingColor: function(value) {
                this.$emit('update-selected-housing-color', value);
            },

            selectedOptics: function(value) {
                this.$emit('update-selected-optics', value);
            },

            selectedProtectionClass: function(value) {
                this.$emit('update-selected-protection-class', value);
            },

            selectedOptions: function(value) {
                this.updateLedConfigurations();
                this.generateSku();
                this.generateProductName();
                this.validateStepOne();

                this.$emit('update-selected-options', value);
            },

            calculatedProductPrice: function(value) {
                this.$emit('update-calculated-product-price', value);
            },

            checkForLuminaireControlReset: function(value) {
                this.$emit('update-luminaire-control-reset', value);
            },

            generatedSku: function(value) {
                this.$emit('update-generated-sku', value);
            },

            /*ledModuleConfiguration: function(value) {
                console.log('ledModuleConfiguration', this.ledModuleConfiguration, this.product_configurator_id);
                this.setLedConfiguration();
            },*/

        },
    }
</script>
